module.exports = __webpack_public_path__ + "img/CRT_P2_Sword-005.ba724914.png";